import { get } from "lodash";
import DocumentUpload from "../DocumentUpload";

const IdentityDocumentSides = ({
  rectoField,
  versoField,
  values,
  setFieldValue,
  createFileRemoveHandler,
  handleDownload,
  errors,
  translate,
  labelKeys = {},
}) => {
  const rectoLabelKey = labelKeys.recto || "CIN_RECTO";
  const versoLabelKey = labelKeys.verso || "CIN_VERSO";

  return (
    <>
      <DocumentUpload
        label={translate?.DOCUMENTS?.[rectoLabelKey]?.LABEL}
        items={get(values, rectoField, [])}
        onDownload={handleDownload}
        onUpload={(item) => {
          setFieldValue(rectoField, item);
        }}
        onFileRemove={createFileRemoveHandler(rectoField)}
        error={get(errors, rectoField)}
        required
      />
      <DocumentUpload
        label={translate?.DOCUMENTS?.[versoLabelKey]?.LABEL}
        items={get(values, versoField, [])}
        onDownload={handleDownload}
        onUpload={(item) => {
          setFieldValue(versoField, item);
        }}
        onFileRemove={createFileRemoveHandler(versoField)}
        error={get(errors, versoField)}
        required
      />
    </>
  );
};

export default IdentityDocumentSides;
